import { EDIT_ACCOUNT_CUSTOM_VIEW_BY_ID } from "@workspace/account/src/store/actionTypes";

export const FETCH_CANDIDATE = "FETCH_CANDIDATE";
export const FETCH_CANDIDATE_SUCCESS = "FETCH_CANDIDATE_SUCCESS";
export const FETCH_CANDIDATE_FAILURE = "FETCH_CANDIDATE_FAILURE";

export const FETCH_CANDIDATES = "FETCH_CANDIDATES";
export const FETCH_CANDIDATES_SUCCESS = "FETCH_CANDIDATES_SUCCESS";
export const FETCH_CANDIDATES_FAILURE = "FETCH_CANDIDATES_FAILURE";

export const CREATE_CANDIDATE = "CREATE_CANDIDATE";
export const CREATE_CANDIDATE_SUCCESS = "CREATE_CANDIDATE_SUCCESS";
export const CREATE_CANDIDATE_FAILURE = "CREATE_CANDIDATE_FAILURE";

export const POST_CANDIDATE = "POST_CANDIDATE";
export const POST_CANDIDATE_SUCCESS = "POST_CANDIDATE_SUCCESS";
export const POST_CANDIDATE_FAILURE = "POST_CANDIDATE_FAILURE";

export const PUT_CANDIDATE = "PUT_CANDIDATE";
export const PUT_CANDIDATE_SUCCESS = "PUT_CANDIDATE_SUCCESS";
export const PUT_CANDIDATE_FAILURE = "PUT_CANDIDATE_FAILURE";

export const DELETE_CANDIDATE = "DELETE_CANDIDATE";
export const DELETE_CANDIDATE_SUCCESS = "DELETE_CANDIDATE_SUCCESS";
export const DELETE_CANDIDATE_FAILURE = "DELETE_CANDIDATE_FAILURE";

export const FETCH_CANDIDATES_FIELDS = "FETCH_CANDIDATES_FIELDS";
export const FETCH_CANDIDATES_FIELDS_SUCCESS =
  "FETCH_CANDIDATES_FIELDS_SUCCESS";
export const FETCH_CANDIDATES_FIELDS_FAILURE =
  "FETCH_CANDIDATES_FIELDS_FAILURE";

export const RESET_META_DATA = "RESET_META_DATA";

export const PUT_CANDIDATE_DRAFT_STATUS = "PUT_CANDIDATE_DRAFT_STATUS";
export const PUT_CANDIDATE_DRAFT_STATUS_SUCCESS =
  "PUT_CANDIDATE_DRAFT_STATUS_SUCCESS";
export const PUT_CANDIDATE_DRAFT_STATUS_FAILURE =
  "PUT_CANDIDATE_DRAFT_STATUS_FAILURE";

export const FETCH_CANDIDATE_DATA = "FETCH_CANDIDATE_DATA";
export const FETCH_CANDIDATE_DATA_SUCCESS = "FETCH_CANDIDATE_DATA_SUCCESS";
export const FETCH_CANDIDATE_DATA_FAILURE = "FETCH_CANDIDATE_DATA_FAILURE";

export const FETCH_CANDIDATES_FIELDS_ALL = "FETCH_CANDIDATES_FIELDS_ALL";
export const FETCH_CANDIDATES_FIELDS_ALL_SUCCESS =
  "FETCH_CANDIDATES_FIELDS_ALL_SUCCESS";
export const FETCH_CANDIDATES_FIELDS_ALL_FAILURE =
  "FETCH_CANDIDATES_FIELDS_ALL_FAILURE";

export const IMPORT_CANDIDATE = "IMPORT_CANDIDATE";
export const IMPORT_CANDIDATE_SUCCESS = "IMPORT_CANDIDATE_SUCCESS";
export const IMPORT_CANDIDATE_FAILURE = "IMPORT_CANDIDATE_FAILURE";

export const IMPORT_CANDIDATE_MULTI = "IMPORT_CANDIDATE_MULTI";
export const IMPORT_CANDIDATE_MULTI_SUCCESS = "IMPORT_CANDIDATE_MULTI_SUCCESS";
export const IMPORT_CANDIDATE_MULTI_FAILURE = "IMPORT_CANDIDATE_MULTI_FAILURE";

export const SET_PARSE_AND_IMPORT_LOADING = "SET_PARSE_AND_IMPORT_LOADING";

// Embedding 21032024
export const UPDATE_CANIDATE_EMBEDDINGS = "UPDATE_CANIDATE_EMBEDDINGS";
export const UPDATE_CANIDATE_EMBEDDINGS_SUCCESS =
  "UPDATE_CANIDATE_EMBEDDINGS_SUCCESS";
export const UPDATE_CANIDATE_EMBEDDINGS_FAILURE =
  "UPDATE_CANIDATE_EMBEDDINGS_FAILURE";

// Candidate Recomendation List
export const CANDIDATE_RECOMMENDATION_LIST = "CANDIDATE_RECOMMENDATION_LIST";
export const CANDIDATE_RECOMMENDATION_LIST_SUCCESS =
  "CANDIDATE_RECOMMENDATION_LIST_SUCCESS";
export const CANDIDATE_RECOMMENDATION_LIST_FAILURE =
  "CANDIDATE_RECOMMENDATION_LIST_FAILURE";

// Reset Cnadidate recommendation list
export const RESET_CANDIDATE_RECOMMENDATION_LIST =
  "RESET_CANDIDATE_RECOMMENDATION_LIST";

export const CREATE_CANDIDATE_CUSTOM_VIEW = "CREATE_CANDIDATE_CUSTOM_VIEW";
export const CREATE_CANDIDATE_CUSTOM_VIEW_SUCCESS =
  "CREATE_CANDIDATE_CUSTOM_VIEW_SUCCESS";
export const CREATE_CANDIDATE_CUSTOM_VIEW_FAILURE =
  "CREATE_CANDIDATE_CUSTOM_VIEW_FAILURE";

export const FETCH_CANDIDATE_CUSTOM_VIEW = "FETCH_CANDIDATE_CUSTOM_VIEW";
export const FETCH_CANDIDATE_CUSTOM_VIEW_SUCCESS =
  "FETCH_CANDIDATE_CUSTOM_VIEW_SUCCESS";
export const FETCH_CANDIDATE_CUSTOM_VIEW_FAILURE =
  "FETCH_CANDIDATE_CUSTOM_VIEW_FAILURE";
// #filter
export const RESET_CANDIDATE_CUSTOM_VIEW = "RESET_CANDIDATE_CUSTOM_VIEW";

export const SELECT_CANDIDATE_CUSTOM_VIEW = "SELECT_CANDIDATE_CUSTOM_VIEW";
export const SELECT_CANDIDATE_CUSTOM_VIEW_SUCCESS =
  "SELECT_CANDIDATE_CUSTOM_VIEW_SUCCESS";
export const SELECT_CANDIDATE_CUSTOM_VIEW_FAILURE =
  "SELECT_CANDIDATE_CUSTOM_VIEW_FAILURE";

export const DELETE_CANDIDATE_CUSTOM_VIEW = "DELETE_CANDIDATE_CUSTOM_VIEW";
export const DELETE_CANDIDATE_CUSTOM_VIEW_SUCCESS =
  "DELETE_CANDIDATE_CUSTOM_VIEW_SUCCESS";
export const DELETE_CANDIDATE_CUSTOM_VIEW_FAILURE =
  "DELETE_CANDIDATE_CUSTOM_VIEW_FAILURE";

// Delete candidates
export const DELETE_CANDIDATES = "DELETE_CANDIDATES";
export const DELETE_CANDIDATES_SUCCESS = "DELETE_CANDIDATES_SUCCESS";
export const DELETE_CANDIDATES_FAILURE = "DELETE_CANDIDATES_FAILURE";
export const DELETE_CANDIDATES_RESET = "DELETE_CANDIDATES_RESET";

// #filter
export const FETCH_CANDIDATE_CUSTOM_VIEW_BY_ID = "FETCH_CANDIDATE_CUSTOM_VIEW_BY_ID";
export const FETCH_CANDIDATE_CUSTOM_VIEW_BY_ID_SUCCESS = "FETCH_CANDIDATE_CUSTOM_VIEW_BY_ID_SUCCESS";
export const FETCH_CANDIDATE_CUSTOM_VIEW_BY_ID_FAILURE = "FETCH_CANDIDATE_CUSTOM_VIEW_BY_ID_FAILURE";

export const EDIT_CANDIDATE_CUSTOM_VIEW_BY_ID = "EDIT_CANDIDATE_CUSTOM_VIEW_BY_ID";
export const EDIT_CANDIDATE_CUSTOM_VIEW_BY_ID_SUCCESS = "EDIT_CANDIDATE_CUSTOM_VIEW_BY_ID_SUCCESS";
export const EDIT_CANDIDATE_CUSTOM_VIEW_BY_ID_FAILURE = "EDIT_CANDIDATE_CUSTOM_VIEW_BY_ID_FAILURE";

export const RESET_CANDIDATES = "RESET_CANDIDATES";

export const UNSELECT_CANDIDATE_CUSTOM_VIEW = "UNSELECT_CANDIDATE_CUSTOM_VIEW";
export const UNSELECT_CANDIDATE_CUSTOM_VIEW_SUCCESS = "UNSELECT_CANDIDATE_CUSTOM_VIEW_SUCCESS";
export const UNSELECT_CANDIDATE_CUSTOM_VIEW_FAILURE = "UNSELECT_CANDIDATE_CUSTOM_VIEW_FAILURE";

// Candidate Static Report
export const FETCH_CANDIDATE_STATIC_REPORT_COUNT = "FETCH_CANDIDATE_STATIC_REPORT_COUNT";
export const FETCH_CANDIDATE_STATIC_REPORT_COUNT_SUCCESS = "FETCH_CANDIDATE_STATIC_REPORT_COUNT_SUCCESS";
export const FETCH_CANDIDATE_STATIC_REPORT_COUNT_FAILURE = "FETCH_CANDIDATE_STATIC_REPORT_COUNT_FAILURE";

export const FETCH_CANDIDATE_STATIC_REPORT_LISTING = "FETCH_CANDIDATE_STATIC_REPORT_LISTING";
export const FETCH_CANDIDATE_STATIC_REPORT_LISTING_SUCCESS = "FETCH_CANDIDATE_STATIC_REPORT_LISTING_SUCCESS";
export const FETCH_CANDIDATE_STATIC_REPORT_LISTING_FAILURE = "FETCH_CANDIDATE_STATIC_REPORT_LISTING_FAILURE";

// Candidate Static Report Filters
export const FETCH_CANDIDATE_STATIC_REPORT_FILTERS = "FETCH_CANDIDATE_STATIC_REPORT_FILTERS";
export const FETCH_CANDIDATE_STATIC_REPORT_FILTERS_SUCCESS = "FETCH_CANDIDATE_STATIC_REPORT_FILTERS_SUCCESS";
export const FETCH_CANDIDATE_STATIC_REPORT_FILTERS_FAILURE = "FETCH_CANDIDATE_STATIC_REPORT_FILTERS_FAILURE";

export const SAVE_CANDIDATE_STATIC_REPORT_FILTERS = "SAVE_CANDIDATE_STATIC_REPORT_FILTERS";
export const SAVE_CANDIDATE_STATIC_REPORT_FILTERS_SUCCESS = "SAVE_CANDIDATE_STATIC_REPORT_FILTERS_SUCCESS";
export const SAVE_CANDIDATE_STATIC_REPORT_FILTERS_FAILURE = "SAVE_CANDIDATE_STATIC_REPORT_FILTERS_FAILURE";

export const RESET_CANDIDATE_STATIC_REPORT_FILTERS = "RESET_CANDIDATE_STATIC_REPORT_FILTERS";

// Candidate Default Custom View
export const SET_CANDIDATE_DEFAULT_CUSTOM_VIEW = "SET_CANDIDATE_DEFAULT_CUSTOM_VIEW";
export const DELETE_CANDIDATE_DEFAULT_CUSTOM_VIEW = "DELETE_CANDIDATE_DEFAULT_CUSTOM_VIEW";

// Toogle Candidate do not disturb
export const TOGGLE_CANDIDATE_DO_NOT_DISTURB = "TOGGLE_CANDIDATE_DO_NOT_DISTURB";
export const TOGGLE_CANDIDATE_DO_NOT_DISTURB_SUCCESS = "TOGGLE_CANDIDATE_DO_NOT_DISTURB_SUCCESS";
export const TOGGLE_CANDIDATE_DO_NOT_DISTURB_FAILURE = "TOGGLE_CANDIDATE_DO_NOT_DISTURB_FAILURE";

export const SET_APPROVE_CREATE_SUCCESS = "SET_APPROVE_CREATE_SUCCESS";
export const RESET_APPROVE_CREATE_SUCCESS = "RESET_APPROVE_CREATE_SUCCESS";

export const SET_HAS_EDITED_CANDIDATE = "HAS_EDITED_CANDIDATE";